import React from "react";
import { Container } from "react-bootstrap";
import iotlog from "../../../../Asset/ai-iot-log-management (1).svg";
import webTesting from "../../../../Asset/web-testing.svg";
import webDeploy from "../../../../Asset/web-deployment.svg";
import ioteasy from "../../../../Asset/ai-iot-easy-deployment.svg";
import webCod from "../../../../Asset/web-coding.svg";

const Third = () => {
  const designProcessCards = [
    {
      id: 1,
      img: iotlog,
      title: "Embrace",
      description:
        "Our UI UX agency uses empathy-driven human-focused design processes to craft the best digital solutions based on the preferences of the end user.",
    },
    {
      id: 2,
      img: webCod,
      title: "Identify the problem (the problem statement)",
      description:
        "In order to solve complex issues with minimal snags, we incorporate perfectly logical and detailed logic with elements such as design functions, features, functionality, workflow, and beyond.",
    },
    {
      id: 3,
      img: ioteasy,
      title: "Inventing new Ideas",
      description:
        "The combination of proven ideation techniques and a client-centric approach enables us to develop roadmaps while mapping your business journey to define problems related to people.",
    },
    {
      id: 4,
      img: webDeploy,
      title: "Prototype",
      description:
        "A results-driven prototype is developed based on diversified experiments to ensure a high degree of quality and detail in creating an authentic digital connection.",
    },
    {
      id: 5,
      img: webTesting,
      title: "Testing",
      description:
        "To impart a clear big picture of design experience benchmarking, blueprints, personas, and journey maps of ideal consumers, we use state-of-the-art testing techniques to refine our designs on Omni-channel platforms.",
    },
  ];
  return (
    <>
      <section
        className="feature-list-block"
        style={{ backgroundColor: "var(--white-color)" }}
      >
        <Container>
          <div className="top-text-third-webDevelopment">
            <h2>
              HOW WE <span>DO ?</span>
            </h2>
          </div>
          <div className="row card-items">
            {designProcessCards.map(({ id, img, title, description }) => (
              <div key={id} className="col-md-4 flex-column mb-50">
                <div className="card-item no-hover">
                  <div className="card-img">
                    <img alt={title} src={img} />
                  </div>
                  <div className="card-content">
                    <h3>{title}</h3>
                    <p className="sort-info">{description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>
    </>
  );
};

export default Third;
